export default "__VITE_ASSET__C0xABm4A__"